import { render, staticRenderFns } from "./WidgetBuilderPreview.vue?vue&type=template&id=12867482&scoped=true&"
import script from "./WidgetBuilderPreview.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilderPreview.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilderPreview.vue?vue&type=style&index=0&id=12867482&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12867482",
  null
  
)

export default component.exports